import { render, staticRenderFns } from "./page-content-wrapper.vue?vue&type=template&id=2aa7e910"
import script from "./page-content-wrapper.vue?vue&type=script&lang=ts"
export * from "./page-content-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports